var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcClosePrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_83_529",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_83_529",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACDklEQVR4nO2cTU7DMBBGswJuUSnOanwItjh7rkR6HhYRF+LnFkElkaj4EbS1x/ONvyd5w+r5qbgpuNN1hBBCCCGEEEIIIeQbw3B3HUPax5Bet7U//Awl1YDgL3J/Jf34GMO4HC/p09Nud3vTGQfC/zdJk7Ko/n9JmpJF9f+vpAlZVP9TJaOx2BD+67vzOJ8qGT/XXPPdHMZ/fQQ6W3KpGTtD5G2lqbjs+ox5cehF+xg597j40T2kN5jQUTF2zsgfq0/PGqGnbMKh/DGS77g4Dj0+lPItKx7KxEZy1flVDPmPEQRH+I2IYTc3GxKDTlmwtDEx5FIECxsUAw4q1NyotBK55oaltcg1Ni6tRtYMIK1H1gghjKzzETgif6wuRYlXX2z9uECLLZ4iW40tHiNbi+06spXYTUSuHbupyLViNxlZO3bTkbViM7JCbEb+AkMrIDw68CNHHiEdH+80EH5g8Rs5tnSMCP+o1E7k6PmVLcYiu4xtNXL0FJv/nFWA1w0U4AUaBXglTAFeclSA13YVsHAXTgw4FMXSBsWQS1YsbkwMOl2E5Q2JYTd3GxEARzdf+x2AXEvN61i0xMvEBprXEYHHSEDN6xDgwShI8zpm6FE/IPM6Zg6v8jTOzIs/xIA+L/4QIye9+EMMUfXiDzEW2Iv/Nuj68Oj3sq40IX3tdwD3J4QQQgghhBBCCOkUeQcgswAds3DTOwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClosePrimary);
export default __webpack_public_path__ + "static/media/ic_close_primary.7d7f27904d3cc60f45142c77c9a5ae47.svg";
export { ForwardRef as ReactComponent };